import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { useRecoilState } from 'recoil';

import { alertsTestIDs, settingsMenuTestIDs, settingsPageTestIDs } from '@constants';
import { helpers } from '@helpers';
import { useContextNodeHandle, useGetGeoLocation } from '@hooks';
import { navigationService } from '@services';
import { screenReaderEnabledState } from '@store';

import { tPath } from './constants';
import { styles } from './styles';

import { TWCButton } from '../../focusable/TWCButton/TWCButton';
import { TWCTileContent } from '../../focusable/TWCTileContent/TWCTileContent';
import { TWCText } from '../../primitives/TWCText/TWCText';

export const AlertLocation = () => {
  const { t } = useTranslation('translation', { keyPrefix: tPath });
  const [screenReaderEnabled] = useRecoilState(screenReaderEnabledState);

  const geoLocation = useGetGeoLocation();

  const itsCorrectButtonHandle = useContextNodeHandle(alertsTestIDs.location.itsCorrectButton);
  const changeLocationButtonHandle = useContextNodeHandle(alertsTestIDs.location.changeLocationButton);

  const location = `${geoLocation.city}, ${geoLocation.state}`;

  useEffect(() => {
    if (helpers.isWeb) {
      setTimeout(() => {
        helpers.FOCUS_NOW(itsCorrectButtonHandle);
      }, 10);
    }
  }, [itsCorrectButtonHandle]);

  return (
    <TWCTileContent height={615} width={674}>
      <View accessibilityRole={'text'} accessible={screenReaderEnabled} style={styles.alertModalContent}>
        <TWCText style={styles.titleText} testID={alertsTestIDs.location.headlineText} variant={'regularText36'}>
          {t('headingText')}
        </TWCText>
        <TWCText
          style={styles.locationText}
          testID={alertsTestIDs.location.locationText}
          variant={'regularText36Transparent'}
        >
          {location}
        </TWCText>
        <TWCButton
          accessibilityHint={`${t('correctButtonAccessibilityHint')} ${t('footerText')}`}
          accessibilityLabel={t('correctButtonAccessibilityLabel', {
            location,
          })}
          nextFocusDown={changeLocationButtonHandle}
          nextFocusLeft={null}
          nextFocusRight={null}
          nextFocusUp={null}
          testID={alertsTestIDs.location.itsCorrectButton}
          title={t('itsCorrectButtonText')}
          onPress={() => {
            navigationService.goBack();
          }}
        />
        <TWCButton
          accessibilityHint={`${t('changeLocationButtonAccessibilityHint', {
            location,
          })} ${t('footerText')}`}
          accessibilityLabel={t('changeLocationButtonAccessibilityLabel')}
          nextFocusDown={null}
          nextFocusLeft={null}
          nextFocusRight={null}
          nextFocusUp={itsCorrectButtonHandle}
          style={styles.changeLocationButton}
          testID={alertsTestIDs.location.changeLocationButton}
          title={t('changeLocationButtonText')}
          onPress={() => {
            navigationService.navigate(settingsPageTestIDs.settingsPage, {
              defaultActiveItem: settingsMenuTestIDs.locations,
            });
          }}
        />
        <TWCText style={styles.helpText} testID={alertsTestIDs.location.helpText} variant={'regularText30Transparent'}>
          {t('footerText')}
        </TWCText>
      </View>
    </TWCTileContent>
  );
};
